import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex); // 必须调用此方法安装插件

// 定义模块（可选）
const moduleA = {
	state: () => ({
		count: 0
	}),
	mutations: {
		increment(state) {
			state.count++;
		}
	}
};

// 创建 Store 实例
export default new Vuex.Store({
	modules: {
		a: moduleA
	}, // 模块化示例
	state: {
		user: null // 全局状态示例
	},
	mutations: {
		setUser(state, payload) {
			state.user = payload;
		}
	},
	actions: {
		fetchUser({
			commit
		}, userId) {
			// 模拟异步操作
			setTimeout(() => {
				commit('setUser', {
					id: userId,
					name: 'John'
				});
			}, 1000);
		}
	},
	getters: {
		isLoggedIn: state => !!state.user // 计算属性示例
	}
});